function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Attack");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Login-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home",
  transform: "translate(-301.000000, -612.000000)"
}, React.createElement("g", {
  id: "Defense",
  transform: "translate(301.000000, 612.000000)"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#1A76E2",
  cx: 8.33333333,
  cy: 8.33333333,
  r: 8.33333333
}), React.createElement("path", {
  d: "M12.2916465,6.39744889 C12.2916465,7.56665025 12.0759685,8.63936404 11.6446128,9.61559025 C11.2700144,10.432896 10.7705498,11.1480385 10.146219,11.7610178 C9.62405131,12.2718339 9.07918081,12.6407567 8.51160747,12.867786 C8.30728103,12.9585977 8.10295459,12.9585977 7.89862816,12.867786 C7.25159444,12.6067023 6.65564234,12.1866979 6.11077184,11.607773 C5.50914409,10.9834421 5.03805806,10.2512724 4.697514,9.41126382 C4.31156397,8.46909201 4.11858909,7.46448703 4.11858909,6.39744889 C4.11858909,6.22717686 4.16399506,6.07393203 4.25480672,5.93771441 C4.34561838,5.80149678 4.47048471,5.70500921 4.62940518,5.64825196 L7.89862816,4.28607572 C8.10295459,4.19526405 8.30728103,4.19526405 8.51160747,4.28607572 L11.7808304,5.64825196 C11.9397509,5.70500921 12.0646172,5.80149678 12.1554289,5.93771441 C12.2462406,6.07393203 12.2916465,6.22717686 12.2916465,6.39744889 Z M8.20511781,11.8120994 C9.05647796,11.392095 9.74891764,10.7450613 10.2824366,9.8709983 C10.872713,8.90612338 11.1792027,7.81070674 11.2019055,6.58474812 L8.20511781,5.3247351 L8.20511781,11.8120994 Z",
  id: "s",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})))));

var SvgDefense = function SvgDefense(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDefense, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Defense.8a84d631.svg";
export { ForwardRef as ReactComponent };